<template>
  <div>
    <a-table v-if="relationIssues.length > 0" :pagination="false" size="small" :columns="selectedColumns" row-key="id" :data-source="relationIssues">
      <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
      <span slot="customTitle" slot-scope="text, record">
        <a-tooltip placement="top" :title="record.title">
          <a class="issue_title" :href="link(record)" target="_blank">{{ record.title }}</a>
        </a-tooltip>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="issueStatus[record.status].status" :text="issueStatus[record.status].label" />
      </span>
      <span slot="action" slot-scope="text, record, index">
        <a v-tc="{ name: '移除缺陷' }" @click="onRemove(index)">移除</a>
      </span>
    </a-table>
    <a-button v-tc="{ name: '选择缺陷' }" icon="search" type="dashed" class="search-button" @click="onSelect"> 选择缺陷 </a-button>
    <a-modal v-model="visible" :width="960" title="选择缺陷" @ok="handleOk" @cancel="close">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="16" style="margin-bottom: 8px">
          <a-col :span="8">
            <a-form-model-item label="标题/ID">
              <a-input v-model="filterForm.title" placeholder="ID或标题筛选" allow-clear @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="与我相关">
              <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
                <a-radio-button value="all"> 全部 </a-radio-button>
                <a-radio-button value="about"> 与我相关 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <a-form-model-item>
              <a-button type="primary" @click="onSearch"> 查询 </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table :loading="loading" :expand-icon-column-index="2" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :data-source="issueData" @change="handleTableChange">
        <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
        <span slot="customTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="issue_title" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="issueStatus[record.status].color"> {{ issueStatus[record.status].label }}</a-tag>
        </span>
        <span slot="type" slot-scope="text, record">{{ issueTypes[record.issue_type] ? issueTypes[record.issue_type].label : '--' }}</span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { issueList } from '@/api/project/issue';
import { issueStatus, issueTypes } from '@/utils/dictionary';
const columns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '类型',
    width: 100,
    scopedSlots: { customRender: 'type' }
  }
];
const selectedColumns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    bugList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    status: {
      type: [Number, Array],
      default: null
    }
  },
  data() {
    return {
      columns,
      issueTypes,
      issueStatus,
      selectedColumns,
      loading: false,
      visible: false,
      issues: {},
      issueData: [],
      selected: [],
      selectedRowKeys: [],
      searchKeyword: '',
      filterForm: {
        title: null,
        about: 'all',
        issue_type: []
      },
      issueIds: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    relationIssues() {
      return this.selected.map(key => {
        return this.issues[key];
      });
    },
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: { project_id: record.project_id },
          query: { issueId: record.id }
        }).href;
      };
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    // value() {
    //   this.selected = this.value;
    // },
    selected() {
      this.$emit('change', this.selected);
    },
    bugList: {
      handler: function () {
        this.issues = this.bugList;
      },
      deep: true,
      immediate: true
    },

    value: {
      handler: function () {
        this.selected = this.value;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getStoryList() {
      this.loading = true;
      issueList({ project_id: this.projectId, ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current, status: this.status })
        .then(res => {
          this.issueData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getStoryList();
    },

    onSearch() {
      this.pagination.current = 1;
      this.getStoryList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.issues, item.id, { id: item.id, key: item.key, title: item.title, status: item.status, project_id: item.project_id });
      });
    },

    onSelect() {
      this.visible = true;
      this.selectedRowKeys = [...this.selected];
      this.getStoryList();
    },

    onRemove(index) {
      this.selected.splice(index, 1);
    },

    handleOk() {
      this.selected = [...this.selectedRowKeys];
      this.close();
    },

    close() {
      this.visible = false;
      this.selectedRowKeys = [];
      this.filterForm = {
        title: null,
        about: 'all',
        issue_type: []
      };
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .search-form {
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
      width: 71%;
    }
  }
}
.search-button {
  width: 100%;
}
.issue_title:hover {
  cursor: pointer;
  color: #1890ff;
}
.issue_title {
  color: rgba(0, 0, 0, 0.65);
}
.requirement_search {
  margin: 8px 0;
}
</style>
